export const getHoursMinutesFrom24hrString = (time: string) => {
  const [hours, minutes] = time.split(':')
  return { hours, minutes }
}
